import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "SuggestsCalendarListContent ofs fl rad8 w98",
  style: {"height":"300px","box-shadow":"0 2px 4px rgba(0, 0, 0, 0.3)","border-top":"1px solid #ebebeb","border-bottom":"1px solid #ebebeb"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "カレンダーが見つかりませんでした。", -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  style: {"width":"30px","height":"30px"},
  class: "fl ml10 mt6"
}
const _hoisted_11 = {
  class: "ml5 fl mt6",
  style: {"width":"calc(100% - 48px)"}
}
const _hoisted_12 = { class: "fs13 mt1 mb1" }
const _hoisted_13 = { class: "grey fs10" }
const _hoisted_14 = {
  class: "fr mr2 posAb mt4",
  style: {"width":"18px","right":"1px"}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_ListLoader = _resolveComponent("ListLoader")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_TextfieldTag, {
      placeholder: "カレンダーを検索",
      style: {"height":"40px","min-width":"180px","max-width":"180px"},
      class: "lineForm fl fs14 CalendarListSearchField",
      value: _ctx.searchText,
      onClickTextfield: _ctx.clickSearchCalendarField,
      onInputValue: _ctx.searchCalnedarValue,
      onBlur: _ctx.blurSearchCalendarField
    }, null, 8, ["value", "onClickTextfield", "onInputValue", "onBlur"]),
    _hoisted_1,
    (_ctx.showSuggests)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.searchedCtags)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ListLoader)
              ]))
            : _createCommentVNode("", true),
          (_ctx.searchedCtags.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                    width: "30",
                    height: "30"
                  }, null, 8, _hoisted_7)
                ])
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedCtags, (ctag, ctagindex) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${ctagindex}${ctag.name}${_ctx.selectingCtag ? _ctx.selectingCtag.search_key : ``}`,
                    style: {"height":"46px"},
                    class: _normalizeClass(`pointer w100 ofh posRe`),
                    onClick: ($event: any) => (_ctx.selectCtag(ctag))
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      (ctag.owner && ctag.owner.image_url)
                        ? (_openBlock(), _createBlock(_component_UserIcon, {
                            key: 0,
                            member: ctag,
                            width: 28,
                            canEdit: false,
                            updateSelf: false,
                            showTooltip: false
                          }, null, 8, ["member"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_ctx.truncate(ctag.name || ``, 20)), 1)
                      ])), [
                        [_directive_tooltip, ctag.name && ctag.name.length > 20 ? ctag.name : null]
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.truncate(ctag.email, 40)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (ctag.writable)
                        ? _withDirectives((_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                            width: "14",
                            height: "14"
                          }, null, 8, _hoisted_15)), [
                            [
                              _directive_tooltip,
                              `書込可能なカレンダー`,
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_16
                  ], 8, _hoisted_9))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}